<template>
  <section class="general">
    <div class="container">
      <div class="general__images">
        <div class="general__img-wrapper">
          <zoom-on-hover
            v-if="getActiveImage"
            :imgNormal="getActiveImage.url"
            :altText="getActiveImage.alt"
            :scale="3"
            class="general__img"
          />
        </div>
        <div v-if="images && images.length > 1" class="general__preview">
          <div
            v-for="(item, n) in images"
            :key="`${item.title}-${n}`"
            class="general__preview-wrapper"
            :class="{ 'general__preview-wrapper--active': activatedImg === n }"
            @click="activateImg(n)"
          >
            <img :src="item.url" :alt="item.alt" class="general__preview-img" />
          </div>
        </div>
      </div>
      <div class="general__descr">
        <h2 class="text-h2 text-color-navy text-weight-bold general__title" v-html="title" />
        <p v-if="subtitle" class="general__subtitle">
          <RichRenderer :richTextData="subtitle" />
        </p>
        <app-button
          id="product-details-learn-more-button"
          :text="$t('product.admetox.headerDetailsBtn')"
          size="small"
          variant="secondary"
          type="button"
          @clicked="$emit('scrollToDetailsRequested')"
        />
      </div>
    </div>
  </section>
</template>
<script>
import ZoomOnHover from '@/components/vendor/vue-zoom-on-hover/ZoomOnHover.vue'

export default {
  name: 'ProductDetailsGeneralSection',
  components: {
    ZoomOnHover,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: Object,
      default: () => null,
    },
    images: {
      type: Array,
      requred: true,
      default: () => [],
    },
  },
  emits: ['scrollToDetailsRequested'],
  data() {
    return {
      activatedImg: 0,
    }
  },
  computed: {
    getActiveImage() {
      return this.images?.find((el, idx) => this.activatedImg === idx)
    },
  },
  methods: {
    activateImg(item) {
      this.activatedImg = item
    },
  },
}
</script>
